import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import WebComponent from '../../../WebComponent.js'
import I18n from '../../../i18n.js'
import './AngebotEgo.js'
import './AngebotEgz.js'
import './AngebotGaznat.js'
import './AngebotGvm.js'
import './AngebotAil.js'

export default class Angebot extends WebComponent {

  static get EVENT_KEYS() {
    return {
      RELOAD_TRIGGERED: 'angebot-reload-triggered',
      DATE_CHANGED: 'angebot-date-changed'
    }
  }

  get css() {
    return css`
      isceco-title:first-of-type {
        display: block;
        margin-top: -20px;
        margin-bottom: -15px;
      }

      .flexRowView {
        display: flex;
        flex-direction: row;

        gap: 10px;
      }

      .dateButtons {
        align-content: center;
      }

      .angebotTable {
        overflow-x: auto;
      }

      #angebot-woche-vorwaerts {
        margin-top: 10px;
      }
    `
  }

  get translationFile() {
    return './views/Admin/Angebot/i18n.json'
  }

  constructor() {
    super()
    this.startDate = new Date();
    this.minStartDate = this.addDays(new Date(), -14);
    this.maxStartDate = this.addDays(new Date(), 7);
    this.modDate = '';
  }

  connectedCallback() {
    super.connectedCallback()

    this._refresh = () => {
      this.render()
    }

    this.render()
    document.addEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)
    document.addEventListener(Angebot.EVENT_KEYS.RELOAD_TRIGGERED, event => {
      this.modDate = event.detail.modDate;
      this._refresh()
    });
  }

  disconnectedCallback() {
    document.removeEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)
    document.removeEventListener(Angebot.EVENT_KEYS.RELOAD_TRIGGERED, this._refresh)
  }

  getTemplate() {
    return html`
      <isceco-title text="${this.i18n.translate('admin.angebot.title')}">
        <nav class="angebot-title-navigation">
          <div class="flexRowView">
            <isceco-button
              id="angebot-speichern"
              variant="primary"
              size="small"
              icon="save"
              title="${this.i18n.translate('admin.angebot.button.speichern.title')}"
              @click="${_ => {
                if (document.getElementById("angebot-form").validate()) {
                  document.getElementById('angebot-confirm-dialog').removeAttribute('hidden')
                }
              }}"
            ></isceco-button>
          </div>
        </nav>
      </isceco-title>
      <p>${this.i18n.translate('admin.angebot.aktualisiert')} ${this.getModTime()}</p>
      <div class="flexRowView">
        <div class="dateButtons">
          <isceco-button
            id="angebot-woche-zurueck"
            variant="primary"
            size="small"
            icon="angle up"
            title="${this.i18n.translate('admin.angebot.button.date.backward.title')}"
            ?disabled="${this.isBackwardButtonDisabled()}"
            @click="${_ => {
              this.changeDate(-7)
            }}"
          ></isceco-button>
          <isceco-button
            id="angebot-woche-vorwaerts"
            variant="primary"
            size="small"
            icon="angle down"
            title="${this.i18n.translate('admin.angebot.button.date.forward.title')}"
            ?disabled="${this.isForwardButtonDisabled()}"
            @click="${_ => {
              this.changeDate(7)
            }}"
          ></isceco-button>
        </div>
        <div class="angebotTable">
          ${this.renderTable()}
        </div>
      </div>
    `
  }

  renderTable() {
    switch (getNavigationHash()) {
      case 'Admin_Angebot_Ego':
        return html`
          <gasmonitoring-frontend-admin-angebot-ego
            start-date="${this.startDate}"
          ></gasmonitoring-frontend-admin-angebot-ego>`
      case 'Admin_Angebot_Egz':
        return html`
          <gasmonitoring-frontend-admin-angebot-egz
            start-date="${this.startDate}"
          ></gasmonitoring-frontend-admin-angebot-egz>`
      case 'Admin_Angebot_Gaznat':
        return html`
          <gasmonitoring-frontend-admin-angebot-gaznat
            start-date="${this.startDate}"
          ></gasmonitoring-frontend-admin-angebot-gaznat>`
      case 'Admin_Angebot_Gvm':
        return html`
          <gasmonitoring-frontend-admin-angebot-gvm
            start-date="${this.startDate}"
          ></gasmonitoring-frontend-admin-angebot-gvm>`
      case 'Admin_Angebot_Ail':
        return html`
          <gasmonitoring-frontend-admin-angebot-ail
            start-date="${this.startDate}"
          ></gasmonitoring-frontend-admin-angebot-ail>`
      default:
        break;
    }
    // default
    return html``
  }

  getModTime() {
    return this.modDate;
  }

  changeDate(change) {
    this.startDate = this.addDays(this.startDate, change);
    send(Angebot.EVENT_KEYS.DATE_CHANGED, {startDate: this.startDate})
  }

  isBackwardButtonDisabled() {
    return this.startDate <= this.minStartDate;
  }

  isForwardButtonDisabled() {
    return this.startDate >= this.maxStartDate;
  }

  addDays(date, days) {
    date.setDate(date.getDate() + days);
    return date;
  }
}
customElements.define('gasmonitoring-frontend-admin-angebot', Angebot)
